import { loadWidget } from "./loader";
export { LiquidSwapWidget } from './main';

loadWidget('liquidswap-widget');

export { loadWidget };